import script from "./skeleton-plan-schedule-loader.vue?vue&type=script&setup=true&lang=js"
export * from "./skeleton-plan-schedule-loader.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__